<ng-container *ngIf="loading">
  <mat-spinner diameter=50 class="aip-spinner"></mat-spinner>
</ng-container>
<ng-container *ngIf="!loading">
  <div class="select-report-container">
    <div class="select-label">Please select report from the dropdown list</div>
    <ng-select
      class="report-select aip-theme-bg"
      appendTo="#reportSelectOverlayDiv"
      [items]="reportList"
      bindValue="id"
      bindLabel="reportname"
      [clearable]="false"
      [searchable]="false"
      [(ngModel)]="selectedReport"
      (change)="loadTableData()">
    </ng-select>
  </div>
  <mat-card class="report-widget-fullscreen mat-elevation-z4">
    <mat-card-content class="report-widget-content-fullscreen">
      <ng-container *ngIf="loadingData">
        <div style="width:100%;height:100%">
          <mat-spinner diameter=50 class="aip-spinner"></mat-spinner>
        </div>
      </ng-container>
    
      <ng-container *ngIf="!loadingData">
        <app-table-report class="table" [tableDef]="tableDef" [data]="tableData" [pagedOn]="tableDef.pagedOn" [filterOn]="tableDef.filterOn" [sortOn]="tableDef.sortOn" [pageLength]="pageLength" [pageIndex]="pageIndex" [pageSize]="pageSize" (reload)="loadTableData()" (gridPageChange)="gridPageChange($event)"></app-table-report>
      </ng-container>
    </mat-card-content>
  </mat-card>
</ng-container>
<div id="reportSelectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>
